import { CONFERENCE_JOINED, DATA_CHANNEL_OPENED, ENDPOINT_MESSAGE_RECEIVED } from '../base/conference/actionTypes';
import { participantUpdated } from '../base/participants/actions';
import { getLocalParticipant } from '../base/participants/functions';
import MiddlewareRegistry from '../base/redux/MiddlewareRegistry';
import { VISUAL_LANGUAGE_ROLE_MESSAGE, VISUAL_LANGUAGE_ROLE_PROPERTY } from './constants';
import { getLocalVisualLanguageRole, getVisualLanguageMediaEvidence, getVisualLanguageMediaPolicy } from './functions';
function asRecord(value) {
    return value && typeof value === 'object' && !Array.isArray(value)
        ? value
        : {};
}
function isVisualRole(value) {
    return value === 'admin-observer'
        || value === 'captioner'
        || value === 'client'
        || value === 'guest'
        || value === 'interpreter';
}
function publishSupportEvidence(store) {
    const evidence = getVisualLanguageMediaEvidence(store.getState());
    const globalScope = typeof window !== 'undefined'
        ? window
        : undefined;
    if (globalScope) {
        globalScope.__MALKA_VISUAL_LANGUAGE_MEDIA_EVIDENCE__ = evidence;
    }
}
function announceLocalRole(store, conference) {
    const state = store.getState();
    const policy = getVisualLanguageMediaPolicy(state);
    if (!policy.enabled || !conference) {
        return;
    }
    const role = getLocalVisualLanguageRole();
    const localParticipant = getLocalParticipant(state);
    if (localParticipant?.id) {
        store.dispatch(participantUpdated({
            id: localParticipant.id,
            local: true,
            malkaVisualRole: role
        }));
    }
    try {
        conference.setLocalParticipantProperty?.(VISUAL_LANGUAGE_ROLE_PROPERTY, role);
        conference.sendEndpointMessage?.('', {
            roomKind: policy.roomKind,
            type: VISUAL_LANGUAGE_ROLE_MESSAGE,
            role
        });
    }
    catch (error) {
        // Role metadata is support/policy evidence; call media should continue if signaling is unavailable.
        console.warn('[visual-language-media-policy] Failed to announce local role', error);
    }
    publishSupportEvidence(store);
}
MiddlewareRegistry.register((store) => next => (action) => {
    const result = next(action);
    switch (action.type) {
        case CONFERENCE_JOINED:
        case DATA_CHANNEL_OPENED:
            announceLocalRole(store, action.conference || store.getState()['features/base/conference'].conference);
            break;
        case ENDPOINT_MESSAGE_RECEIVED: {
            const data = asRecord(action.data);
            if (data.type !== VISUAL_LANGUAGE_ROLE_MESSAGE || !isVisualRole(data.role)) {
                break;
            }
            const participantId = action.participant?.getId?.();
            if (participantId) {
                store.dispatch(participantUpdated({
                    id: participantId,
                    malkaVisualRole: data.role
                }));
            }
            publishSupportEvidence(store);
            break;
        }
    }
    return result;
});
